import React from "react";
import { useLang } from "../i18n/LanguageContext";

export default function LanguageToggle({ className = "" }) {
  const { lang, setLang } = useLang();
  const btn = (code, label) => (
    <button
      type="button"
      onClick={() => setLang(code)}
      data-testid={`lang-toggle-${code}`}
      className={`px-2 py-1 text-[0.7rem] tracking-[0.22em] uppercase transition-colors ${
        lang === code
          ? "text-[#D4B16A]"
          : "text-white/45 hover:text-white/75"
      }`}
      aria-pressed={lang === code}
      aria-label={`Switch to ${label}`}
    >
      {label}
    </button>
  );

  return (
    <div
      className={`inline-flex items-center border border-white/10 ${className}`}
      data-testid="language-toggle"
    >
      {btn("en", "EN")}
      <span className="w-px h-3 bg-white/10" />
      {btn("es", "ES")}
    </div>
  );
}
